/* tslint:disable */
 
import { FileModel } from './file-model';
import { ReferenceProperty } from './reference-property';
export class EmailLog {
  attachments?: Array<null | FileModel>;
  bcc?: Array<string>;

  /**
   * The body of the Email.
   */
  body?: string;
  cc?: Array<string>;
  dataEntry?: ReferenceProperty;

  /**
   * The error message generated in case an exception is thrown.
   */
  errorMessage?: string;

  /**
   * The event type of reaction that caused the email to be sent.
   */
  eventType?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 20 | 100;

  /**
   * The sender email address.
   */
  from?: string;

  /**
   * The timestamp when the Email was generated by the system.
   */
  generatedAt?: string;
  generatedBy?: ReferenceProperty;
  id?: string;

  /**
   * The message id from the service bus.
   */
  messageId?: string;

  /**
   * The related trigger execution id if the Email was sent as a result of a trigger.
   */
  relatedTriggerExecutionId?: string;

  /**
   * The response returned frm the SMTP provider.
   */
  responseCode?: any;

  /**
   * Whether the Email was sent successfully or not.
   */
  status?: string;

  /**
   * The subject of the Email.
   */
  subject?: string;

  /**
   * The timestamp when the Email was sent.
   */
  timestamp?: string;
  to?: Array<string>;
}
